<template>
  <div class="dict-content">
    <div class="searchDiv">
      <div class="queryConditionDiv">
        <a-input v-model="searchModel.description" class="marginRight_12 searchColInput" placeholder="定时任务描述"></a-input>
        <a-button class="marginRight_12" type="primary" @click="search()">查询</a-button>
        <a-button @click="reset()">重置</a-button>
      </div>
    </div>
    <a-table
      :columns="tableData.columns"
      :data-source="tableData.data"
      :pagination="tableData.pagination"
      :rowKey="record => record.id"
      :scroll="{ y: tableHeight }"
      class="listTable"
      @change="handleTableChange">
      <template slot="actions" slot-scope="text, record">
        <a href="javascript:" @click="handleEdit(record)" v-if="$auth('timingTask.edit')">
          编辑
        </a>
      </template>
    </a-table>
    <edit-modules ref="editModules" @getTableData="getTableData"></edit-modules>
  </div>

</template>

<script>
import editModules from '@/views/timingTask/modules/timingTaskTable/modules/editModules.vue'
import { timedTasks } from '@/api/timingTask'

export default {
  name: 'TimingTaskTable',
  components: { editModules },
  data () {
    return {
      // 搜索条件
      searchModel: {
        description: ''
      },
      // 表格
      tableData: {
        columns: [
          {
            title: '序号',
            customRender: (text, record, index) => `${index + 1}`,
            width: 70
          },
          {
            title: '定时任务描述',
            dataIndex: 'description'
          },
          {
            title: '触发频率',
            customRender: (text, record, index) => `每${record.dayNumber ? record.dayNumber : '-'}天${record.time ? record.time : '-'}时`
          },
          {
            title: '上一次执行时间',
            dataIndex: 'executionTime'
          },
          {
            title: '下一次执行时间',
            dataIndex: 'nextExecutionTime'
          },
          {
            title: '操作',
            width: 200,
            scopedSlots: {
              customRender: 'actions'
            }
          }
        ],
        data: [],
        pagination: {
          pageNum: 1,
          pageSize: 20,
          total: 0,
          pageSizeOptions: ['10', '20', '30', '40'],
          showSizeChanger: true,
          showQuickJumper: true
        }
      },
      tableHeight: 'calc(100vh - 223px)'
    }
  },
  created () {
    this.getTableData()
  },
  methods: {
    // 获取表格数据
    getTableData () {
      const params = {
        description: this.searchModel.description,
        ...this.tableData.pagination
      }
      timedTasks(params).then(res => {
        if (res.status === 0) {
          this.tableData.data = res.data.list
          this.tableData.pagination.total = res.data.total
        } else {
          this.$message.error(res.info.message)
        }
      })
        .catch(err => {
          this.$message.error(err.info.message)
        })
    },
    // 切换页码
    handleTableChange (pagination) {
      this.tableData.pagination.pageNum = pagination.current
      this.tableData.pagination.pageSize = pagination.pageSize
      this.getTableData()
    },
    // 搜索
    search () {
      this.getTableData()
    },
    // 重置
    reset () {
      this.searchModel = {
        description: ''
      }
      this.getTableData()
    },
    // 打开编辑弹窗
    handleEdit (record) {
      this.$refs.editModules.setTitle('编辑定时任务')
      this.$refs.editModules.setModel(record)
      this.$refs.editModules.open(true)
    }
  }
}
</script>

<style lang="less" scoped>
.dict-content {
  overflow-y: hidden;
  background-color: #ffffff;
  height: 100%;
}
.searchDiv {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  .searchColInput {
    width: 200px;
  }
}
.marginRight_12 {
  margin-right: 12px;
}

/deep/.listTable  {
  height: calc(100% - 50px);
  >.ant-spin-nested-loading {
    height: 100%;
    >.ant-spin-container {
      height: calc(100% - 50px);
      .ant-table {
        height: calc(100% - 64px);
        .ant-table-content {
          height: 100%;
          .ant-table-scroll{
            height: 100%;
            .ant-table-body {
              height: calc(100% - 40px);
            }
          }
        }
      }
      .ant-table-placeholder {
        position: absolute;
        background: none;
        border-top: none;
        border-bottom: none;
        border-radius: 0 0 4px 4px;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        height: 100px;
        .ant-empty-normal {
          margin: 0 !important;
        }
      }
    }
  }
}
/deep/.ant-form-item {
  display: flex;
}
</style>
